/* SeverityComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;

const Renderer = require("./SeverityRenderer");
const _ = require("lodash");
const severityLabels = {
    CRITICAL: "Critical",
    MAJOR: "Major",
    MINOR: "Minor",
    INFO: "Informational"
};
class SeverityColumnComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._Severity = severityLabels[value];
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._Severity = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setSeverity(newVal);
        }
    }

    getValue() {
        return this.getSeverity();
    }

    setSeverity(newVal) {
        this._Severity = severityLabels[newVal];
        this.emit("Severity", newVal);
        return this;
    }

    getSeverity() {
        return this._Severity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SeverityColumnComponent;
